<ng-container *ngIf="loaded">
  <mc-license-avatar *ngIf="license" [disabled]="true" [disabledTooltip]="true" [license]="license" size="large"></mc-license-avatar>
  <mc-central-avatar *ngIf="!license" [disabledTooltip]="true" name="MadCap Central" size="large"></mc-central-avatar>
</ng-container>